export const TnC = () => {
  return (
    <div
      className="relative"
      style={{
        minHeight: '100%',
        backgroundImage: 'url("../images/abstract_bg_white.svg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
      <div
        style={{
          background:
            'linear-gradient(to bottom, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, .85) 100%)',
          height: '100%'
        }}
        className=" px-3 py-3 text-justify">
        کاربران در نرم افزار مدمی می توانند از بخش ابتدایی برنامه به طور رایگان استفاده کرده و از
        محتوایی که شرکت فرا رایانه آسان درمان به طور استاندارد توسط پزشکانی که با این شرکت قرارداد
        همکاری دارند تولید شده است استفاده کنند. کاربران برای استفاده از خدمات تشخیصی نیاز به تبت
        نام برای برنامه دارند در حین ثیت نام اطلاعاتی نظیر نام و نام خانوادگی, شماره تلفن و کد ملی
        از کاربر دریافت می شود که این اطلاعات به دلیل این است که کاربران به صورت یکتا در این پلتفرم
        ثبت نام شوند و با یک شماره تلفن یا یک کد ملی افراد به طور متعدد ثبت نام نکنند. همچنین کد ملی
        کاربران برای اتصال به سامانه نسخه های آنلاین در آینده مورد نیاز است. چراکه شرکت های بیمه
        کننده مانند سازمان تامین اجنماعی یا بیمه سلامت برای شناسی کاربر و ارائه خدمات نسخه نویسی
        آنلاین براساس کد ملی افراد به ارائه خدمت اقدام می کند. شرکت فراد خود را ملزم و متعهد می داند
        که تمامی تلاش خود را جهت حفظ و نگهداری اطلاعاتی که کاربر در اختیار آن شرکت قرار می دهد را به
        کار برد تا از حفاظت و حراست از این اطلاعات اطمینان حاصل کند. همچنین شرکت متعهد می شود که این
        اطلاعات را عامدانه در اختیار افراد حقیقی یا حقوقی ثالت قرار ندهد و از آنها به عنوان داده های
        تبلیغاتی نیز استفاده نکند. شرکت فراد می کوشد تا از طرق سخت افزاری ونرم افزاری در مراقبت و
        حفاظت از اطلاعات کاربران نهایت دانش و تلاش خود را به کار برد. همچنین اطلاعات ورود کاربران به
        صورت رمزنگاری شده می باشد تا اشخاصی با اهداف خرابکارانه نتوانند به اطلاعات کاربران دست پیدا
        کنند. کاریران نیز با استفاده از خدمات این نرم افزار به طور ضمنی قوانین و سیاست های حفظ حریم
        خصوصی را می پذیرند و همینطور به شرکت فرا رایانه آسان درمان این مجوز را می دهند که اطلاعات
        ایشان در سرور های این شرکت ذخیره شوند. شرکت فراد هم نسبت به کاربرانش متعهد است که از اطلاعات
        ایشان استفاده تبلیغاتی نکند.
      </div>
    </div>
  );
};
